import { getBackendAuthHeaders } from '../../../shared/services/backendAuthService';

function normalizeOrgBackendUrl(raw: string): string {
  let u = raw.trim().replace(/\/$/, '');
  if (!u.startsWith('http://') && !u.startsWith('https://')) {
    u = u.startsWith('/') ? 'http://localhost:8001' : `https://${u}`;
  }
  return u;
}

export interface ExtractFieldsResponse {
  fields?: string[];
}

export async function extractFieldsViaOrganizationBackend(
  templateId: string,
  options: { execution_template_id?: string | null; from_latest?: boolean }
): Promise<ExtractFieldsResponse> {
  const raw = process.env.VITE_ORGANIZATION_BACKEND_URL || '';
  if (!raw) {
    throw new Error('VITE_ORGANIZATION_BACKEND_URL is not configured');
  }
  const base = normalizeOrgBackendUrl(raw);
  const headers = await getBackendAuthHeaders(true);
  const res = await fetch(`${base}/templates/${templateId}/extract-fields`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      execution_template_id: options.execution_template_id ?? null,
      from_latest: options.from_latest ?? false,
    }),
  });
  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { detail?: string | unknown[] };
    let msg = res.statusText;
    const d = err.detail;
    if (typeof d === 'string') msg = d;
    else if (Array.isArray(d)) msg = d.map((x) => String(x)).join(' ');
    throw new Error(msg || `extract-fields failed (${res.status})`);
  }
  return (await res.json()) as ExtractFieldsResponse;
}

export async function getTemplateBlockSlotsViaOrganizationBackend(
  templateId: string
): Promise<{ slotCount: number; block_placeholder_count?: number }> {
  const raw = process.env.VITE_ORGANIZATION_BACKEND_URL || '';
  if (!raw) {
    throw new Error('VITE_ORGANIZATION_BACKEND_URL is not configured');
  }
  const base = normalizeOrgBackendUrl(raw);
  const headers = await getBackendAuthHeaders(false);
  const res = await fetch(`${base}/templates/${templateId}/blocks`, { headers });
  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { detail?: string };
    throw new Error(err.detail || res.statusText || `get blocks failed (${res.status})`);
  }
  const data = (await res.json()) as { block_placeholder_count?: number };
  const n = data.block_placeholder_count ?? 4;
  return { slotCount: n, block_placeholder_count: data.block_placeholder_count };
}
